import React from 'react';
import { XIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { painPoints } from '../data/painPoints';
export function PainPointsSection() {
  return <section className="bg-brand-sand px-4 py-20 md:py-24" data-id="element-134" data-mp="2hu4wmqruev06">
      <Reveal className="mx-auto max-w-5xl" data-id="element-135" data-mp="2wqmaboni8lpw">
        <div className="mb-10 text-center" data-id="element-136" data-mp="2rpycaj0uz4m6">
          <h2 className="text-3xl font-extrabold text-brand-deep md:text-4xl" data-id="element-137" data-mp="2rp5ck20bhfdj">Ti suona familiare?</h2>
          <p className="mt-3 text-brand-gray" data-id="element-138" data-mp="35oep8rpbdrcr">
            Non sei solo/a: è la quotidianità della maggior parte dei docenti di Geografia.
          </p>
        </div>
        <div className="grid gap-5 sm:grid-cols-2" data-id="element-139" data-mp="3fg2aubz6we6b">
          {painPoints.map(({
          title,
          description
        }) => <article key={title} className="flex gap-4 rounded-2xl border border-brand-ocean/[0.07] bg-brand-alt p-6 shadow-sm" data-id="element-140" data-mp="3ag68eh654usv">
              <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-brand-red/10 text-brand-red" data-id="element-141" data-mp="3ogqoh5ko8cio">
                <XIcon className="h-4 w-4" strokeWidth={3} aria-hidden="true" data-id="element-142" data-mp="3kcss32mqdftb" />
              </span>
              <div className="min-w-0" data-id="element-143" data-mp="sx4f9l1fn6mc">
                <h3 className="font-bold leading-snug text-brand-deep" data-id="element-144" data-mp="wvleliem3ct7">{title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-brand-gray" data-id="element-145" data-mp="11uwwiuqpsocd">{description}</p>
              </div>
            </article>)}
        </div>
        <p className="mt-10 text-center font-display text-2xl font-bold italic text-brand-ocean" data-id="element-146" data-mp="16sg7nls48l03">
          Se hai risposto sì a uno di questi… abbiamo la soluzione.
        </p>
      </Reveal>
    </section>;
}